import apiClient from 'apiClient';
import withCaseErrorMiddleware from '../caseError/withCaseErrorMiddleware';
import { CaseResponse, PatchCaseResponseData } from '../types';
import { Fields } from './types';

const patch = (endpoint: string) => (fields: Fields): CaseResponse => {
  const bodyEntries = fields.map((field) => [field.fieldName, field.fieldValue]);
  const body = Object.fromEntries(bodyEntries);
  return apiClient.patch<PatchCaseResponseData>(endpoint, body).then(withCaseErrorMiddleware);
};

export default patch;
